/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	const irNewsJson = () => {
		if($('.top-slide').length) {
			if(!$('.top-slide-item').length) {
				$('.top-slideWrap').addClass('di_none');
			}
			if($('.top-slide-item').length == 1 ) {
				$('.top-slide').slick({
					autoplay: false,
					slidesToShow: 4,
					slidesToScroll: 1,
					arrows: true,
					prevArrow: '<a class="slick-prev" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
					nextArrow: '<a class="slick-next" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
					dots: false,
					infinite: true,
					responsive: [{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							arrows: false,
							dots: true,
						}
					}]
				});
				$('.top-slide').find('.slick-active').addClass(a);
				$('.top-slide').addClass('_item01');
			} else {
				$('.top-slide').slick({
					autoplay: true,
					slidesToShow: 4,
					slidesToScroll: 1,
					arrows: true,
					prevArrow: '<a class="slick-prev" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
					nextArrow: '<a class="slick-next" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
					dots: false,
					infinite: true,
					responsive: [{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							arrows: false,
							dots: true,
						}
					}]
				});
			}
			const getJSONIr = () => {
				return $.ajax({
					type: 'GET',
					url: `https://d3fjlg9o357v7o.cloudfront.net/${location.pathname.split('/')[1]}/ir/ir_release.json`,
					dataType: 'json'
				});
			};
			const irDataMolding = (_ir) => {
				// console.log(irData, 'irData');
				// irニュースの配列作成
				let irDataList = [];
				for(let k = 0; k < _ir.length; k++) {
					let itemListyear = _ir[k].PUBLISHED.substr(0,4);
					let itemListmonth = Number(_ir[k].PUBLISHED.substr(4,2));
					let itemListday = Number(_ir[k].PUBLISHED.substr(6,2));
					let itemListmonthEn = '';
					switch(itemListmonth) {
						case 1 : itemListmonthEn = 'January'; break;
						case 2 : itemListmonthEn = 'February'; break;
						case 3 : itemListmonthEn = 'March'; break;
						case 4 : itemListmonthEn = 'April'; break;
						case 5 : itemListmonthEn = 'May'; break;
						case 6 : itemListmonthEn = 'June'; break;
						case 7 : itemListmonthEn = 'July'; break;
						case 8 : itemListmonthEn = 'August'; break;
						case 9 : itemListmonthEn = 'September'; break;
						case 10 : itemListmonthEn = 'October'; break;
						case 11 : itemListmonthEn = 'November'; break;
						case 12 : itemListmonthEn = 'December'; break;
						default: itemListmonthEn = 1;
					}
					irDataList[k] = {
						jsoncategory: 'ir',
						year: _ir[k].PUBLISHED.substr(0,4),
						date: _ir[k].PUBLISHED,
						dateEn: itemListmonthEn+' '+itemListday+', '+itemListyear,
						title: _ir[k].TITLE,
						pdfSize: _ir[k].SIZE,
						target: _ir[k].TARGET,
						href: _ir[k].LINK,
						new: _ir[k].NEW,
						icon: _ir[k].ICON
					};
				}
				return irDataList;
			};
			const irListSort = ($ir) => {
				// リスト成型
				let itemList = irDataMolding($ir);
				// 配列を日付順でソート
				itemList.sort(function($itemlista, $itemlistb){
					return($itemlista.date < $itemlistb.date ? 1 : -1);
				});
				return itemList;
			};
			const itemListHTML = ($listArray,$loopNum) => {
				let HTML = '';
				if(!$listArray.length) {
					let lang = location.pathname.split('/')[1];
					if(location.pathname.split('/')[1] === 'global') {
						lang = 'glo';
					}
					if(lang === 'ja') {
						HTML = '<p>こちらのニュースはございません</p>';
					} else {
						HTML = '<p>There is no news here.</p>';
					}
				} else {
					$('.js-news-json ul').remove();
					HTML = '<ul>';
					for (let j=0; j < $loopNum; j++) {
						// console.log(j,$listArray[j],'$listArray[j]');
						// 日付日英だし分け
						let _day ='';
						if(location.pathname.split('/')[1] === 'global') {
							_day = '<p class="mod-news-item-top-day ls_en">'+$listArray[j].dateEn+'</p>';
						} else {
							_day = '<p class="mod-news-item-top-day ls_en">'+$listArray[j].year+'.'+$listArray[j].date.substr(4,2)+'.'+$listArray[j].date.substr(6,2)+'</p>';
						}
						let _link = '';
						if(!$listArray[j].pdfSize) {
							if(!$listArray[j].href) {
								_link = '<div class="mod-news-item-title mod-spacer-24_16">'+
								'<span>'+$listArray[j].title+'</span>'+
								'</div>';
							} else {
								_link = '<a href="'+$listArray[j].href+'" class="di_block hov_c_blue" target="'+$listArray[j].target+'">'+
								'<div class="mod-news-item-title mod-spacer-24_16">'+
								'<span>'+$listArray[j].title+'</span>'+
								'</div>'+
								'</a>';
							}
						} else {
							_link = '<a href="'+$listArray[j].href+'" class="di_block hov_c_blue" target="_blank">'+
							'<div class="mod-news-item-title mod-spacer-24_16">'+
							'<span>'+$listArray[j].title+'</span>'+
							'<svg class="mod-news-item-title-pdf_icon"><use xlink:href="/common/svg/sprite.svg#pdf"></use></svg>'+
							'<span class="mod-news-item-title-file_size">'+$listArray[j].pdfSize+'</span>'+
							'</div>'+
							'</a>';
						}
						HTML += '<li class="mod-news-item">'+
						'<div class="mod-news-item-top">'+
						_day+
						'</div>'+
						_link+
						'</li>';
					}
					HTML += '</ul>';
				}
				$(HTML).appendTo($('.js-top-ir-news-json'));
			};
			getJSONIr().done((ir) => {
				// irリストを成形
				let irList = irListSort(ir.ir_release);
				itemListHTML(irList,5);
			});
		}
	};
	irNewsJson();

})(window.jQuery, window.FUNCTIONS);
